module.exports = __webpack_public_path__ + "img/adv_generator_encounter.23e84e39.svg";